import { Alert, AlertDescription } from '@/components/ui/alert';
import { UserManagementPage } from '@/pages/settings/users';
import { ModeProvider } from '@/providers/ModeProvider';

interface Step2Props {
  skipped: boolean;
}

export function Step2UserAccess({ skipped }: Step2Props) {
  return (
    <div className="flex flex-col h-full">
      {/* Step header */}
      <div className="mb-5 shrink-0">
        <h2 className="text-xl font-semibold mb-1">User & Role Verification</h2>
        <p className="text-sm text-muted-foreground">
          Review your users and assign them access to the companies you've just created. Use the ⋮ menu next to each
          user and click <strong>Manage Companies</strong>.
        </p>
      </div>

      {/* Skip info banner */}
      {skipped && (
        <Alert className="mb-4 border-amber-200 bg-amber-50 text-amber-800 shrink-0">
          <AlertDescription className="text-amber-800">
            You've skipped this step. You can still assign company access later via{' '}
            <strong>Settings → Users → User Management</strong>, using the ⋮ menu against a user and clicking{' '}
            <strong>Manage Companies</strong>.
          </AlertDescription>
        </Alert>
      )}

      {/* Embedded User Management */}
      <div className="flex-1 min-h-0 overflow-auto rounded-xl border bg-background">
        <div className="p-1">
          <ModeProvider>
            <UserManagementPage />
          </ModeProvider>
        </div>
      </div>
    </div>
  );
}
